import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import EditClaimEstateModal from '../components/edit-claim-modal/Modal';
import { getClaims, getClaimsReport } from '../../../services/claim';
import { get, set } from '../../../services/storage';
import ClaimUpdatesListModal from './claim-updates-list-modal/Modal';
import CreateClaimEstateModal from './create-claim-modal/Modal';
import CreateOtherProductClaimModal from './create-other-product-claim-modal/Modal';
import {
  ClaimProductTypeEnum,
  ClaimProductTypeLabels
} from '../enums/ClaimProductType.enum';
import {
  Dimmer,
  Table,
  Segment,
  Loader,
  Label,
  Popup,
  Menu,
  Icon,
  Grid,
  Dropdown,
  Confirm
} from 'semantic-ui-react';
import { iRootDispatch, iRootState } from '../../../store';
import { connect } from 'react-redux';
import { AvailableBrokersAndEstatesState } from '../../../store/types/temp-types';
import { CustoDropDownItemProps } from '../types/CustoDropDownItem';
import { maskCpfOrCnpj } from '../../../services/masks';
import DetailModal from './DetailModal';
import styled from 'styled-components';
import { translateStatus, translatePropertyStatus } from '../util';
import ModalAttachFiles from '../../../components/ModalAttachFiles';
import { FileIdentifiersAll } from '../types/FileIdentifiersClaimEstate.enum';
import { UserRolesEnum } from '../../../enums/user-roles.enum';
import { useDropDownUsers } from '../../../services/broker';
import moment from 'moment-timezone';
import { sendMessage, sendWebhookFiles } from '../../../services/followup';
import AuthorizationContainer from '../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../enums/authz-feature.enum';
import { useHistory, useLocation } from 'react-router-dom';
import { ClaimEstatesStatusEnum } from '../types/ClaimEstatesStatusEnum';
import { claimEstatesStatusFilterOptions } from '../constants/ClaimEstatesStatusEnum';
import { extractApiErrorMessages } from '../../../utils/apiErrorHandler';
import { dangerNotification, successNotification } from '../../../services/notification';
import { deleteClaimDraft } from '../../../services/claims';
// import * as Sentry from '@sentry/react';
import { ReportModal } from '../../../components/ReportModal';
import IconButton from '../../../components/IconButton';
import TablePaginationMenu from '../../../components/TablePaginationMenu';
import EstateUnitFilter from '../../../components/EstateUnitFilter';
import { getListEmptyMessage } from '../../../utils/estateUnitEmptyState.util';
import { ClaimFilterStatus } from '../types/ClaimFilterStatusTypes';
import Button from '../../../components/Button';
import FilterBar, {
  FilterField,
  FilterValues,
  toDateOnlyString,
  toFilterIdList
} from '../../../components/Filter';
import VacatePropertyClaimModal from './vacate-property-claim-modal/Modal';
import { getFileIdentifiers } from './create-claim-modal/utils';
import { ClaimPropertyStatusEnum } from '../../../enums/claim-property-status.enum';
import { CreateClaimEstateInitialInitialValuesType } from './create-claim-modal/Formik/types/CreateClaimEstateInitialValuesTypes';
import PopupModal from '../../../components/PopupModal';
import { BannerLocationActivationEnum } from '../../../types/Banner';
import { PolicyForGetBondInsurancePoliciesListResponseDTO } from '../../../dtos/bond-insurance-policy-list/interfaces/policy-for-get-bond-insurance-policies-list-response-dto';
import SetEstateResponsibleModal from './SetEstateResponsibleModal';
import { getUsers } from '../../../services/estate';
import { UserState } from '../../../types/UserState';
import { isEstateRole as checkIsEstateRole } from '../../../utils/isEstateRole';

interface LocationState {
  claimId?: string;
  openEditModal?: boolean;
  openCreateClaimModal?: boolean;
  selectedPolicyForClaim?: PolicyForGetBondInsurancePoliciesListResponseDTO;
}

const ClickableTableCell = styled(Table.Cell)`
  cursor: pointer;
  position: relative;
`;

const ClickableTableRow = styled(Table.Row)`
  :hover {
    background-color: #f0f0f0;
  }
`;

const ClickableTableHeader = styled(Table.HeaderCell)`
  cursor: pointer !important;

  :hover {
    background-color: #f0f0f0 !important;
  }
`;

export const FieldLabel = styled.label<{ paddingTop?: boolean }>`
  font-weight: bold;
  padding-top: ${props => (props.paddingTop ? '14px' : '0px')};
  text-transform: uppercase;
  margin-left: 5px;
`;

export const FieldValue = styled.p`
  padding-left: 5px;
`;

const FilteredColumn = styled(Grid.Column)<{ borderLeft?: boolean }>`
  padding: 5px;
  cursor: pointer;
  border-left: ${props => (props.borderLeft ? '1px solid #aaa' : '0')};
`;

export const LabelBadge = styled.div<{ color: string }>`
  display: inline-block;
  background-color: ${props => props.color};
  border-radius: 15px;
  padding: 0.5833em 0.833em;
  width: 40px;
  line-height: 9px;
  font-size: 13px;
`;

export const SpanNumBadge = styled.span<{ checked: boolean }>`
  padding-left: 4px;
  color: ${props => (props.checked ? 'black' : 'gray')};
`;

export const DivTextBadge = styled.div<{ checked: boolean }>`
  padding-top: 2px;
  color: ${props => (props.checked ? 'black' : '#aaa')};
`;

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

const claimPropertiesStatusEnum = [
  {
    index: 0,
    value: 'null',
    text: 'Todos'
  },
  {
    index: 1,
    value: 'OCCUPIED',
    text: 'Ocupado'
  },
  {
    index: 2,
    value: 'VACANT',
    text: 'Desocupado'
  }
];

const TYPE_OPTIONS = [
  {
    index: 1,
    value: 'name',
    text: 'Nome do locatário'
  },
  {
    index: 2,
    value: 'document',
    text: 'CPF ou CNPJ'
  },
  {
    index: 3,
    value: 'address',
    text: 'Endereço do imóvel'
  },
  {
    index: 4,
    value: 'claimCode',
    text: 'Código do sinistro'
  },
  {
    index: 5,
    value: 'processNumber',
    text: 'Número do processo'
  },
  {
    index: 6,
    value: 'policyNumber',
    text: 'Número da apólice'
  },
  {
    index: 7,
    value: 'propertyCode',
    text: 'Código do imóvel'
  }
];

const isDraftOnlyFilter = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.length === 1 && String(value[0]) === 'DRAFT';
  }
  return value === 'DRAFT';
};

const FILTER_INITIAL_VALUES: FilterValues = {
  type: 'document',
  argument: '',
  claimEstateStatus: [],
  claimPropertyStatus: [],
  productType: [],
  start: '',
  end: '',
  estateId: '',
  insurerId: [],
  responsibleId: [],
  estateResponsibleId: '',
  estateUnitId: '',
  onlyUnread: false
};

const ClaimTable = (props: any) => {
  const [isClaimUpdatesListModalIsOpen, setClaimUpdatesListModalIsOpen] =
    useState<boolean>(false);
  const [isEditModalIsOpen, setEditModalIsOpen] = useState<boolean>(false);
  const [id, setId] = useState('');
  const userId = get('uid');

  const { availableBrokersAndEstates, user } = props;
  const estates: CustoDropDownItemProps[] = availableBrokersAndEstates.estates;
  const allInsurers: CustoDropDownItemProps[] = availableBrokersAndEstates.insurers.map(
    (insurer: any) => ({
      index: insurer.value.id,
      value: insurer.value.id,
      text: insurer.value.name
    })
  );

  const insurers: CustoDropDownItemProps[] = allInsurers.concat({
    key: '297c0ed6-a9ea-48d3-b0da-235597ae9f7a',
    value: '297c0ed6-a9ea-48d3-b0da-235597ae9f7a',
    text: 'Liberty Seguros'
  } as any);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [responsibleOptions, setResponsibleOptions] = useState<CustoDropDownItemProps[]>(
    []
  );
  const [estateResponsibleOptions, setEstateResponsibleOptions] = useState<
    CustoDropDownItemProps[]
  >([]);
  const [isEstateResponsibleLoading, setIsEstateResponsibleLoading] =
    useState<boolean>(false);
  const [openSetEstateResponsible, setOpenSetEstateResponsible] =
    useState<boolean>(false);
  const [insurersOptions, setInsurersOptions] = useState<CustoDropDownItemProps[]>([]);
  const [estatesOptions, setEstatesOptions] = useState<CustoDropDownItemProps[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [claimUpdatesInitialTab, setClaimUpdatesInitialTab] = useState<
    'follow-up' | 'action-history' | 'porto' | 'garantti'
  >('follow-up');
  const [data, setData] = useState<any[]>([]);
  const [count, setCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isBlocked, setIsBlocked] = useState(false);
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const location = useLocation();
  const history = useHistory();
  const initialClaimId =
    (location.state as LocationState)?.claimId ||
    new URLSearchParams(location.search).get('claimId') ||
    undefined;
  const [claimId, setClaimId] = useState<any>(initialClaimId);
  const initialOpenEditModal = (location.state as LocationState)?.openEditModal;
  const [openEditModal, setOpenEditModal] = useState<any>(initialOpenEditModal);
  const initialOpenCreateClaimModal = (location.state as LocationState)?.openCreateClaimModal;
  const initialSelectedPolicyForClaim = (location.state as LocationState)
    ?.selectedPolicyForClaim;
  const [openCreateClaimModal, setOpenCreateClaimModal] = useState<boolean>(
    Boolean(initialOpenCreateClaimModal && initialSelectedPolicyForClaim)
  );
  const [selectedPolicyForClaim, setSelectedPolicyForClaim] =
    useState<PolicyForGetBondInsurancePoliciesListResponseDTO | null>(
      initialSelectedPolicyForClaim || null
    );
  const [draftIdToResume, setDraftIdToResume] = useState<string | null>(null);
  const [draftProductTypeToResume, setDraftProductTypeToResume] =
    useState<ClaimProductTypeEnum>(ClaimProductTypeEnum.BOND);
  const [draftToDelete, setDraftToDelete] = useState<string | null>(null);
  const [isDeletingDraft, setIsDeletingDraft] = useState(false);
  const [openRowActionsId, setOpenRowActionsId] = useState<string | null>(null);
  const [cloneIdToClone, setCloneIdToClone] = useState<string | null>(null);
  const [cloneProductType, setCloneProductType] = useState<ClaimProductTypeEnum>(
    ClaimProductTypeEnum.BOND
  );
  const [editIdToEdit, setEditIdToEdit] = useState<string | null>(null);
  const [editProductType, setEditProductType] = useState<ClaimProductTypeEnum>(
    ClaimProductTypeEnum.FIRE
  );
  const [filters, setFilters] = useState<FilterValues>({});
  const filtersRef = useRef(filters);
  const claimIdRef = useRef(claimId);
  const fetchGenerationRef = useRef(0);

  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);

  useEffect(() => {
    claimIdRef.current = claimId;
  }, [claimId]);

  const [reportModalIsOpen, setReportModalIsOpen] = useState<boolean>(false);
  const [reportState, setReportState] = useState<number | undefined>(undefined);
  const [sortColumn, setSortColumn] = useState<string | null>('createdAt');
  const [sortDirection, setSortDirection] = useState<'ASC' | 'DESC'>('DESC');
  const [statusCount, setStatusCount] = useState<ClaimFilterStatus>({
    countNew: undefined,
    countUnread: undefined,
    countOld: undefined,
    countDraft: undefined
  });
  const [openVacateModal, setOpenVacateModal] = useState<boolean>(false);
  const [claimVacate, setClaimVacate] = useState<{
    id: string;
    insurerName: string;
  } | null>(null);

  const normalizeFilters = useCallback(async (filtersToNormalize: any) => {
    const validFilters: any = {};

    for (const key in filtersToNormalize) {
      const value = filtersToNormalize[key];

      if (value === '' || value === false || value == null || key === 'argument') {
        continue;
      }

      if (Array.isArray(value) && value.length === 0) {
        continue;
      }

      if (key === 'start' || key === 'end') {
        const dateOnly = toDateOnlyString(value);
        if (dateOnly) validFilters[key] = dateOnly;
        continue;
      }

      if (key === 'type') {
        const argument = String(filtersToNormalize.argument || '').trim();
        if (!argument) continue;
        const searchKey = filtersToNormalize[key];
        validFilters[searchKey] =
          searchKey === 'document' ? argument.replace(/\D/g, '') : argument;
        continue;
      }

      validFilters[key] = value;
    }

    return validFilters;
  }, []);

  const handleReportModalClose = () => {
    setReportModalIsOpen(false);
  };

  const handleOpen = () => {
    setClaimUpdatesListModalIsOpen(true);
  };

  const {
    data: users,
    isLoading: isResponsibleLoading,
    isError
  } = useDropDownUsers(userId ?? '');

  useEffect(() => {
    if (isError) {
      dangerNotification('Ops...', 'Erro ao carregar campo responsável.');
    }

    if (users && !isError) {
      const nonResponsible = {
        key: 0,
        value: 'null',
        text: 'Não Atribuído'
      };

      const newUsers = users.map((userItem: any) => {
        const { id, name } = userItem;

        const returnUser: CustoDropDownItemProps = {
          key: id,
          value: id,
          text: name
        };

        return returnUser;
      });

      const finalUsers = [nonResponsible, ...newUsers];

      setResponsibleOptions(finalUsers);
    }
  }, [users, isError]);

  useEffect(() => {
    const loadEstateResponsibleOptions = async () => {
      if (!user.role.includes('ESTATE')) {
        return;
      }

      const estateId =
        user?.estate?.id || availableBrokersAndEstates?.activeEstateId;

      if (!estateId) {
        return;
      }

      setIsEstateResponsibleLoading(true);
      try {
        const estateUsers = await getUsers(estateId);
        const options = estateUsers.map((estateUser: UserState, index: number) => ({
          key: index + 1,
          value: estateUser.id,
          text: estateUser.name
        }));

        setEstateResponsibleOptions([
          {
            key: 0,
            value: 'null',
            text: 'Sem responsável'
          },
          ...options
        ]);
      } catch (error) {
        dangerNotification('Ops...', 'Erro ao carregar responsáveis da imobiliária.');
      } finally {
        setIsEstateResponsibleLoading(false);
      }
    };

    loadEstateResponsibleOptions();
  }, [user, availableBrokersAndEstates?.activeEstateId]);

  const getCountData = useCallback(async () => {
    const filtersData: any = {
      page: 1,
      userId,
      isRv: true,
      onlyCount: true
    };

    const dataNew = await getClaims({ filters: { ...filtersData, isNew: true } });
    const dataUnread = await getClaims({ filters: { ...filtersData, isUnread: true } });
    const dataOld = await getClaims({ filters: { ...filtersData, isOld: true } });
    const dataDraft = await getClaims({
      filters: { ...filtersData, claimEstateStatus: 'DRAFT' }
    });

    setStatusCount({
      countNew: dataNew.count,
      countUnread: dataUnread.count,
      countOld: dataOld.count,
      countDraft: dataDraft.count
    });
  }, [userId]);

  const getData = useCallback(async () => {
    if (!estates.length) return;

    const generation = ++fetchGenerationRef.current;
    setIsLoading(true);

    try {
      const activeClaimId = claimIdRef.current;
      const normalizedFilters = await normalizeFilters(filtersRef.current);
      const filtersData: any = {
        page: currentPage,
        userId,
        isRv: true,
        ...normalizedFilters
      };

      const claims =
        activeClaimId !== undefined
          ? await getClaims({ id: activeClaimId, filters: filtersData })
          : await getClaims({
              filters: filtersData,
              sortColumn: sortColumn,
              sortDirection: sortDirection
            });

      if (generation !== fetchGenerationRef.current) {
        return;
      }

      if (activeClaimId) {
        setData([
          {
            id: claims.id,
            createdAt: claims.createdAt,
            status: claims.status,
            pendingResponsible: claims.pendingResponsible,
            pendingType: claims.pendingType,
            insurerName: claims.insurer?.name,
            productType: claims.productType || ClaimProductTypeEnum.BOND,
            estateName: claims.estate?.name,
            tenantName: claims.claimTenant?.fullName,
            tenantDocument: claims.claimTenant?.document,
            propertyStreet: claims.claimProperty?.street,
            propertyNumber: claims.claimProperty?.number,
            propertyComplement: claims.claimProperty?.complement,
            propertyDistrict: claims.claimProperty?.district,
            propertyCity: claims.claimProperty?.street,
            propertyState: claims.claimProperty?.state,
            propertyStatus: claims.claimProperty?.status,
            responsibleName: claims.responsible?.name,
            unreadMessagesCount:
              claims.messages?.filter((message: any) => {
                const isUnread = !message.viewed && message.senderId?.id !== userId;
                const isUserEstateRole =
                  user.role === UserRolesEnum.estateAdmin ||
                  user.role === UserRolesEnum.estateUser;
                const isSenderEstateRole =
                  message.senderId?.role === UserRolesEnum.estateAdmin ||
                  message.senderId?.role === UserRolesEnum.estateUser;

                return (
                  isUnread &&
                  ((isUserEstateRole && !isSenderEstateRole) ||
                    (!isUserEstateRole && isSenderEstateRole))
                );
              })?.length || 0
          }
        ]);
        setCount(1);
      } else {
        setData(claims.data);
        if (currentPage === 1) setCount(claims.count);
      }

      setClaimId(undefined);
    } finally {
      if (generation === fetchGenerationRef.current) {
        setIsLoading(false);
      }
    }
  }, [
    currentPage,
    estates.length,
    normalizeFilters,
    sortColumn,
    sortDirection,
    user.role,
    userId
  ]);

  const handleClose = () => {
    setClaimUpdatesListModalIsOpen(false);
    setSelectedItem(null);
    setClaimUpdatesInitialTab('follow-up');
    setEditModalIsOpen(false);
    getData();
    getCountData();
  };

  const handleExportData = async (values: FilterValues) => {
    if (!toFilterIdList(values.claimEstateStatus) && (values.start === '' || values.end === '')) {
      dangerNotification(
        'Ops...',
        'Selecione ao menos o filtro de Status ou um período na Data de cadastro.'
      );
      return;
    }

    if (values.start !== '' && values.end !== '') {
      const startDate = moment(values.start).format('YYYY-MM-DD');
      const endDate = moment(values.end).format('YYYY-MM-DD');

      if (moment(startDate).isAfter(endDate)) {
        dangerNotification(
          'Ops...',
          'A data de início não pode ser maior que a data de fim.'
        );
        return;
      }

      if (moment(endDate).diff(moment(startDate), 'years') > 0) {
        dangerNotification(
          'Ops...',
          'O intervalo entre as datas não pode ser maior que 1 ano'
        );
        return;
      }
    }

    setIsLoading(true);

    try {
      const normalizedFilters = await normalizeFilters(values);
      const filtersData: any = {
        page: currentPage,
        userId,
        ...normalizedFilters
      };

      const status = await getClaimsReport({ filters: { ...filtersData, isRv: true } });

      if (!status) {
        dangerNotification('Ops...', 'Erro ao solicitar relatório de sinistros.');
      } else {
        setReportState(status);
        setReportModalIsOpen(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClaimUpdatesList = (id: string, item: any, status: string) => {
    const garanttiUnread = !isEstateUser ? Number(item?.unreadGaranttiLogsCount || 0) : 0;
    setId(id);
    setSelectedItem(item);
    setClaimUpdatesInitialTab(garanttiUnread > 0 ? 'garantti' : 'follow-up');
    setClaimUpdatesListModalIsOpen(true);
    setIsBlocked(status === 'FINISHED');
  };

  const handleEdit = (id: string) => {
    setId(id);
    setEditModalIsOpen(true);
  };

  const handleConfirmDeleteDraft = async () => {
    if (!draftToDelete) return;

    setIsDeletingDraft(true);
    try {
      await deleteClaimDraft(draftToDelete);
      successNotification(
        'Sucesso',
        'Rascunho excluído com sucesso. Ele não aparecerá mais na plataforma nem nos lembretes por e-mail.'
      );
      setDraftToDelete(null);
      await getData();
      await getCountData();
    } catch (err) {
      const message = extractApiErrorMessages(
        err,
        'Não foi possível excluir o rascunho.'
      );
      dangerNotification('Erro', message);
    } finally {
      setIsDeletingDraft(false);
    }
  };

  const openDetailModal = (id: string) => {
    setId(id);
    setOpenDetail(true);
  };

  async function callback(fileTypes: string[], files: any[], claim_id: string) {
    if (fileTypes) {
      let message = 'Foram anexados os seguintes arquivos: ';
      message += `${fileTypes.join(', ')}.`;
      try {
        await sendMessage(claim_id, user.id, message, user.name);
        if (
          user.role === UserRolesEnum.estateAdmin ||
          user.role === UserRolesEnum.estateUser
        ) {
          await sendWebhookFiles(claim_id, files);
        }
      } catch (err) {
        dangerNotification(
          'Erro',
          'Erro ao enviar notificação de followup, por favor, envie manualmente.'
        );
        // Sentry.captureException(err, {
        //   tags: {
        //     page: 'claim_estates/components/Table.tsx',
        //     claimId: claim_id,
        //     user: user,
        //     fileTypes: fileTypes ? fileTypes.join(', ') : 'undefined',
        //   }
        // });
      }
    } else {
      await sendMessage(claim_id, user.id, 'Arquivos foram anexados', user.name);
    }
  }

  const handleChangeBadge = async (type: string) => {
    setIsLoading(true);
    const filterProp: {
      isNew: boolean;
      isUnread: boolean;
      isOld: boolean;
      claimEstateStatus: string[];
    } = {
      isNew: false,
      isUnread: false,
      isOld: false,
      claimEstateStatus: []
    };
    switch (type) {
      case 'new':
        filterProp.isNew = true;
        break;
      case 'unread':
        filterProp.isUnread = true;
        break;
      case 'old':
        filterProp.isOld = true;
        break;
      case 'draft':
        filterProp.claimEstateStatus = ['DRAFT'];
        break;
    }

    try {
      const nextFilters = {
        ...filters,
        ...filterProp
      };
      filtersRef.current = nextFilters;
      setCurrentPage(1);
      setFilters(nextFilters);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchFormSubmit = (nextFilters: FilterValues) => {
    const next = {
      ...nextFilters,
      isNew: false,
      isUnread: false,
      isOld: false
    };
    // Atualiza o ref na hora para evitar race com fetch em voo / efeitos
    filtersRef.current = next;
    setCurrentPage(1);
    setFilters(next);
  };

  const hasBadgeFilters = Boolean(
    filters?.isNew ||
      filters?.isUnread ||
      filters?.isOld ||
      isDraftOnlyFilter(filters?.claimEstateStatus)
  );

  const handleVacate = (id: string, insurerName: string) => {
    setClaimVacate({ id, insurerName });
    setOpenVacateModal(true);
  };

  useEffect(() => {
    if (!estates.length) return;
    getData();
  }, [getData, filters, estates.length]);

  useEffect(() => {
    getCountData();
  }, [getCountData]);

  useEffect(() => {
    if (!insurersOptions.length) {
      const insurersOptions = insurers.map((insurer: any) => ({
        key: insurer.index,
        value: insurer.value,
        text: insurer.text
      }));

      setInsurersOptions(insurersOptions);
    }

    if (!estatesOptions.length) {
      const estatesOptions = estates.map((estate: any) => ({
        key: estate.value.id,
        value: estate.value.id,
        text: estate.text
      }));

      setEstatesOptions(estatesOptions);
    }
  }, [availableBrokersAndEstates, estates, estatesOptions, insurers, insurersOptions]);

  // Limpa deep-link uma vez, via react-router (não sobrescrever window.history
  // a cada mudança de location — isso quebrava o syncToUrl do FilterBar).
  useEffect(() => {
    const state = location.state as LocationState | undefined;
    if (
      !state?.claimId &&
      !state?.openCreateClaimModal &&
      !state?.selectedPolicyForClaim
    ) {
      return;
    }

    history.replace({
      pathname: location.pathname,
      search: location.search,
      state: {
        ...state,
        claimId: undefined,
        openCreateClaimModal: undefined,
        selectedPolicyForClaim: undefined
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (openEditModal && claimId) {
      handleEdit(claimId);
    }
  }, [openEditModal, claimId]);

  const isEstateUser = checkIsEstateRole(user?.role);

  const filterFields: FilterField[] = useMemo(() => {
    const toSelectOptions = (items: CustoDropDownItemProps[]) =>
      items.map(item => ({
        value: String(item.value),
        label: String(item.text)
      }));

    const fields: FilterField[] = [
      {
        kind: 'search',
        name: 'search',
        label: 'Pesquisar',
        placeholder: 'Digite...',
        defaultType: 'document',
        types: TYPE_OPTIONS.map(option => ({
          value: option.value,
          label:
            option.value === 'document' ? 'CPF/CNPJ' : option.text
        })),
        width: 1.6
      },
      ...(isEstateUser
        ? []
        : [
            {
              kind: 'select' as const,
              name: 'estateId',
              label: 'Imobiliária',
              placeholder: 'Selecione',
              options: toSelectOptions(estatesOptions)
            }
          ]),
      {
        kind: 'multiSelect',
        name: 'insurerId',
        label: 'Seguradora',
        placeholder: 'Selecione',
        options: toSelectOptions(insurersOptions)
      },
      {
        kind: 'dateRange',
        name: 'period',
        label: 'Período',
        startName: 'start',
        endName: 'end',
        placeholder: 'Selecione'
      },
      {
        kind: 'multiSelect',
        name: 'claimEstateStatus',
        label: 'Status',
        placeholder: 'Selecione',
        options: claimEstatesStatusFilterOptions.map(option => ({
          value: String(option.value),
          label: option.text
        }))
      },
      {
        kind: 'multiSelect',
        name: 'productType',
        label: 'Tipo de Sinistro',
        placeholder: 'Selecione',
        advanced: true,
        options: Object.values(ClaimProductTypeEnum).map(value => ({
          value,
          label: ClaimProductTypeLabels[value]
        }))
      },
      {
        kind: 'custom',
        name: 'estateUnitId',
        label: 'Unidade',
        advanced: true,
        getDisplayValue: values => {
          if (!values.estateUnitId) return undefined;
          if (values.estateUnitId === 'null') return 'Sem unidade';
          return String(values.estateUnitId);
        },
        render: ({ values, setValue }) => (
          <EstateUnitFilter
            estateId={String(values.estateId || user.estate?.id || '')}
            value={values.estateUnitId || ''}
            onChange={value => setValue('estateUnitId', value)}
            upward
          />
        )
      },
      ...(isEstateUser
        ? []
        : [
            {
              kind: 'multiSelect' as const,
              name: 'responsibleId',
              label: 'Responsável',
              placeholder: 'Selecione',
              advanced: true,
              loading: isResponsibleLoading,
              options: toSelectOptions(responsibleOptions)
            }
          ]),
      {
        kind: 'multiSelect',
        name: 'claimPropertyStatus',
        label: 'Status do imóvel',
        placeholder: 'Selecione',
        advanced: true,
        options: claimPropertiesStatusEnum.map(option => ({
          value: option.value,
          label: option.text
        }))
      },
      {
        kind: 'checkbox',
        name: 'onlyUnread',
        label: 'Mensagens não lidas',
        advanced: true,
        getDisplayValue: values => (values.onlyUnread ? 'Sim' : undefined)
      }
    ];

    return fields;
  }, [
    estatesOptions,
    insurersOptions,
    isEstateUser,
    isResponsibleLoading,
    responsibleOptions,
    user.estate
  ]);

  const SortableHeaderCell = ({
    columnKey,
    children
  }: {
    columnKey: string;
    children: React.ReactNode;
  }) => {
    const isActive = sortColumn === columnKey;
    const indicator = isActive ? (
      <IconButton
        name={
          sortDirection === 'ASC'
            ? 'long arrow alternate up'
            : 'long arrow alternate down'
        }
      />
    ) : null;

    const handleSort = () => {
      if (isActive) {
        setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
      } else {
        setSortColumn(columnKey);
        setSortDirection('ASC');
      }
    };

    return (
      <ClickableTableHeader textAlign="center" onClick={handleSort}>
        {children} {indicator}
      </ClickableTableHeader>
    );
  };

  const trigger = <IconButton name="ellipsis vertical" />;

  return (
    <>
      <Confirm
        open={!!draftToDelete}
        onCancel={() => setDraftToDelete(null)}
        onConfirm={handleConfirmDeleteDraft}
        cancelButton="Cancelar"
        confirmButton="Excluir rascunho"
        header="Excluir rascunho de sinistro"
        content="Esta ação é irreversível. O rascunho será removido da plataforma e deixará de aparecer nos lembretes por e-mail. Apenas rascunhos podem ser excluídos por aqui."
        size="small"
      />
      {reportModalIsOpen && reportState === 200 ? (
        <ReportModal
          isOpen={reportModalIsOpen}
          header="Relatório de Sinistros"
          message={`
              O relatório será gerado em background e será enviado o link para download via e-mail.
              Atenção, só será possível gerar um novo relatório após a finalização desse.
            `}
          onClose={handleReportModalClose}
        />
      ) : (
        <ReportModal
          isOpen={reportModalIsOpen}
          header="Relatório de Sinistros"
          message="Já existe um relatório na fila para ser gerado, aguarde a notificação via email."
          onClose={handleReportModalClose}
        />
      )}

      {isClaimUpdatesListModalIsOpen && (
        <ClaimUpdatesListModal
          isOpen={isClaimUpdatesListModalIsOpen}
          isBlocked={isBlocked}
          onOpen={handleOpen}
          onClose={handleClose}
          claim={selectedItem}
          header="Atualização do Sinistro"
          id={id}
          user={user}
          initialTab={claimUpdatesInitialTab}
        />
      )}

      <FilterBar
        fields={filterFields}
        initialValues={FILTER_INITIAL_VALUES}
        onSearch={handleSearchFormSubmit}
        onClear={() => setCurrentPage(1)}
        loading={isLoading}
        syncToUrl
        urlNamespace="claims"
        hasExternalActiveFilters={hasBadgeFilters}
        actions={
          user.role && user.role.includes('BROKER') ? (
            <Button
              light
              disabled={isLoading}
              type="button"
              onClick={() => handleExportData(filters)}
              content="Exportar"
              style={{ height: 38, minWidth: 110 }}
            />
          ) : null
        }
      >
        {!isEstateUser && (
          <Grid stackable style={{ marginTop: 4 }}>
            <Grid.Row>
              <FilteredColumn width={2} onClick={() => handleChangeBadge('new')}>
                <LabelBadge color="#6FCA7D" />{' '}
                <SpanNumBadge checked={filters?.isNew}>
                  {statusCount.countNew !== undefined
                    ? `(${statusCount.countNew})`
                    : ''}
                </SpanNumBadge>
                <DivTextBadge checked={filters?.isNew}>Novos sinistros</DivTextBadge>
              </FilteredColumn>
              <FilteredColumn
                width={2}
                borderLeft
                onClick={() => handleChangeBadge('unread')}
              >
                <LabelBadge color="#00A2DD" />{' '}
                <SpanNumBadge checked={filters?.isUnread}>
                  {statusCount.countUnread !== undefined
                    ? `(${statusCount.countUnread})`
                    : ''}
                </SpanNumBadge>
                <DivTextBadge checked={filters?.isUnread}>Não lidos</DivTextBadge>
              </FilteredColumn>
              <FilteredColumn
                width={2}
                borderLeft
                onClick={() => handleChangeBadge('old')}
              >
                <LabelBadge color="#ECA800" />{' '}
                <SpanNumBadge checked={filters?.isOld}>
                  {statusCount.countOld !== undefined
                    ? `(${statusCount.countOld})`
                    : ''}
                </SpanNumBadge>
                <DivTextBadge checked={filters?.isOld}>
                  Solicitados há 7 dias ou mais
                </DivTextBadge>
              </FilteredColumn>
              <FilteredColumn
                width={2}
                borderLeft
                onClick={() => handleChangeBadge('draft')}
              >
                <LabelBadge color="#59249B" />{' '}
                <SpanNumBadge checked={isDraftOnlyFilter(filters?.claimEstateStatus)}>
                  {statusCount.countDraft !== undefined
                    ? `(${statusCount.countDraft})`
                    : ''}
                </SpanNumBadge>
                <DivTextBadge checked={isDraftOnlyFilter(filters?.claimEstateStatus)}>
                  Rascunhos
                </DivTextBadge>
              </FilteredColumn>
            </Grid.Row>
          </Grid>
        )}
      </FilterBar>


      <Table celled>
        <Table.Header fullWidth>
          <Table.Row>
            <SortableHeaderCell columnKey="createdAt">Solicitado em</SortableHeaderCell>
            <SortableHeaderCell columnKey="updatedAt">
              Data de atualização
            </SortableHeaderCell>
            <SortableHeaderCell columnKey="insurerName">Seguradora</SortableHeaderCell>
            <SortableHeaderCell columnKey="estateName">Imobiliária</SortableHeaderCell>
            <SortableHeaderCell columnKey="tenantName">Inquilino</SortableHeaderCell>
            <SortableHeaderCell columnKey="propertyStreet">Endereço</SortableHeaderCell>
            <SortableHeaderCell columnKey="status">Status</SortableHeaderCell>
            <SortableHeaderCell columnKey="unreadMessagesCount">Ações</SortableHeaderCell>
          </Table.Row>
        </Table.Header>
        <Dimmer.Dimmable as={Table.Body} dimmed={isLoading}>
          {isLoading && (
            <Dimmer active blurring>
              <Loader />
            </Dimmer>
          )}
          {data.length > 0 ? (
            <>
              {data.map((item: any) => {
                const {
                  id,
                  createdAt,
                  updatedAt,
                  status,
                  insurerName,
                  productType,
                  estateName,
                  tenantName,
                  tenantDocument,
                  propertyStreet,
                  propertyNumber,
                  propertyComplement,
                  propertyDistrict,
                  propertyCity,
                  propertyState,
                  propertyStatus,
                  unreadMessagesCount,
                  unreadPortoLogsCount,
                  unreadGaranttiLogsCount,
                  estateResponsible
                } = item;

                const resolvedProductType =
                  (productType as ClaimProductTypeEnum) || ClaimProductTypeEnum.BOND;
                const productLabel =
                  ClaimProductTypeLabels[resolvedProductType] ||
                  ClaimProductTypeLabels[ClaimProductTypeEnum.BOND];
                const productIcon =
                  resolvedProductType === ClaimProductTypeEnum.FIRE
                    ? 'fire'
                    : resolvedProductType === ClaimProductTypeEnum.LENDER
                      ? 'handshake'
                      : resolvedProductType === ClaimProductTypeEnum.CONDOMINIUM
                        ? 'building'
                        : resolvedProductType === ClaimProductTypeEnum.CONTENT
                          ? 'box'
                          : 'home';

                const fullAddress = `${propertyStreet}, ${propertyNumber}${
                  propertyComplement ? ` ${propertyComplement}` : ''
                } - ${propertyDistrict} - ${propertyCity} - ${propertyState}`;
                const address = `${propertyStreet}, ${propertyNumber}${
                  propertyComplement ? ` ${propertyComplement}` : ''
                }`;
                const popupAddress = () => (
                  <>
                    <span>{fullAddress}</span>
                    <br />
                    <strong>Imóvel {translatePropertyStatus(propertyStatus)}</strong>{' '}
                    <Icon
                      name={'circle'}
                      color={propertyStatus === 'OCCUPIED' ? 'red' : 'green'}
                    />
                  </>
                );

                // Remove o timezone da string e trata como UTC antes de converter para o timezone local
                const createdAtWithoutTimezone = createdAt?.replace(
                  /[+-]\d{2}:\d{2}$/,
                  ''
                );
                const createdAtFormatted = moment
                  .utc(createdAtWithoutTimezone)
                  .tz('America/Sao_Paulo')
                  .format(`DD/MM/YYYY HH:mm`)
                  .split(' ');
                const updatedAtWithoutTimezone = updatedAt?.replace(
                  /[+-]\d{2}:\d{2}$/,
                  ''
                );
                const updatedAtFormatted = updatedAt
                  ? moment
                      .utc(updatedAtWithoutTimezone)
                      .tz('America/Sao_Paulo')
                      .format(`DD/MM/YYYY HH:mm`)
                      .split(' ')
                  : ' - ';
                return (
                  <>
                    <ClickableTableRow key={id!}>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                        collapsing
                      >
                        {createdAtFormatted[0]} <br /> {createdAtFormatted[1]}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                        collapsing
                      >
                        {updatedAtFormatted[0]} <br /> {updatedAtFormatted[1]}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                        width={2}
                        style={{
                          textOverflow: 'ellipsis',
                          wordWrap: 'nowrap'
                        }}
                      >
                        {insurerName}
                        <br />
                        <span style={{ color: '#777', fontSize: 12 }}>
                          <Icon name={productIcon as any} /> {productLabel}
                        </span>
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                      >
                        {estateName}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                      >
                        {tenantName}
                        <br />
                        <span style={{ color: '#777' }}>
                          ({maskCpfOrCnpj(tenantDocument)})
                        </span>
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        style={{ cursor: 'default' }}
                        textAlign={'center'}
                      >
                        <Popup
                          content={popupAddress}
                          as={Segment}
                          style={{ border: '2px solid #dfdfdf' }}
                          position={'left center'}
                          trigger={
                            <span style={{ cursor: 'help' }}>
                              {address}
                              <br />
                              <span style={{ color: '#777' }}>
                                ({translatePropertyStatus(propertyStatus)})
                              </span>
                            </span>
                          }
                        />
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                      >
                        {estateResponsible && (
                          <Popup
                            trigger={
                              <span style={{ marginRight: 6 }}>
                                <IconButton name="user" size="large" />
                              </span>
                            }
                            content={estateResponsible.name}
                          />
                        )}
                        {translateStatus(status)}
                      </ClickableTableCell>
                      <Table.Cell>
                        <Menu compact>
                          {status !== ClaimEstatesStatusEnum.draft && (
                            <Menu.Item>
                              {(() => {
                                const garanttiUnread = !isEstateUser
                                  ? Number(unreadGaranttiLogsCount || 0)
                                  : 0;
                                const portoUnread = !isEstateUser
                                  ? Number(unreadPortoLogsCount || 0)
                                  : 0;
                                const followupUnread = Number(unreadMessagesCount || 0);
                                const tooltipParts: string[] = [];
                                if (garanttiUnread > 0) {
                                  tooltipParts.push(
                                    `${garanttiUnread} atualizaç${
                                      garanttiUnread === 1 ? 'ão' : 'ões'
                                    } da Garantti`
                                  );
                                }
                                if (portoUnread > 0) {
                                  tooltipParts.push(
                                    `${portoUnread} atualizaç${
                                      portoUnread === 1 ? 'ão' : 'ões'
                                    } da Porto`
                                  );
                                }
                                if (followupUnread > 0) {
                                  tooltipParts.push(
                                    `${followupUnread} mensagem${
                                      followupUnread === 1 ? '' : 'ns'
                                    } interna${followupUnread === 1 ? '' : 's'}`
                                  );
                                }
                                const ariaLabel =
                                  tooltipParts.join(' e ') || 'Atualizações do sinistro';
                                const badge =
                                  garanttiUnread > 0
                                    ? { color: 'orange' as const, count: garanttiUnread }
                                    : portoUnread > 0
                                      ? { color: 'blue' as const, count: portoUnread }
                                      : followupUnread !== 0
                                        ? { color: 'red' as const, count: followupUnread }
                                        : null;
                                return (
                                  <>
                                    <Popup
                                      content={ariaLabel}
                                      trigger={
                                        <span>
                                          <Button
                                            primary
                                            icon="chat"
                                            aria-label={ariaLabel}
                                            onClick={() => {
                                              handleClaimUpdatesList(id, item, status);
                                            }}
                                          />
                                        </span>
                                      }
                                    />
                                    {badge ? (
                                      <Label
                                        color={badge.color}
                                        circular
                                        floating
                                        aria-label={ariaLabel}
                                      >
                                        {badge.count}
                                      </Label>
                                    ) : null}
                                  </>
                                );
                              })()}
                            </Menu.Item>
                          )}
                          {status === ClaimEstatesStatusEnum.draft ? (
                            <>
                              {/* Qualquer usuário com acesso à listagem pode retomar o próprio rascunho;
                                  a validação de propriedade e de status é feita pelo backend. */}
                              <Button
                                style={{ margin: 0 }}
                                type="button"
                                color="blue"
                                onClick={() => {
                                  setDraftProductTypeToResume(resolvedProductType);
                                  setDraftIdToResume(id);
                                }}
                              >
                                <Icon name={'play'} />
                                Retomar Sinistro
                              </Button>
                              <AuthorizationContainer
                                action={ActionEnum.delete}
                                feature={FeatureEnum.claims}
                              >
                                <Button
                                  style={{ margin: 0, marginLeft: 8 }}
                                  type="button"
                                  color="red"
                                  disabled={isDeletingDraft}
                                  onClick={() => setDraftToDelete(id)}
                                >
                                  <Icon name="trash" />
                                  Excluir rascunho
                                </Button>
                              </AuthorizationContainer>
                            </>
                          ) : (
                            <Menu.Item>
                              <Dropdown
                                trigger={trigger}
                                icon={null}
                                direction="left"
                                open={openRowActionsId === id}
                                onOpen={() => {
                                  // Evita reabrir o menu via Space enquanto a modal de anexos está aberta
                                  if (document.querySelector('.ui.modal.visible')) return;
                                  setOpenRowActionsId(id);
                                }}
                                onClose={() => setOpenRowActionsId(null)}
                              >
                                <Dropdown.Menu style={{ zIndex: 1000 }}>
                                  <>
                                    <Dropdown.Item>
                                      <ModalAttachFiles
                                        message={`A inserção de documentos é obrigatória para a abertura do sinistro.`}
                                        trigger={
                                          <Button
                                            type="button"
                                            color="teal"
                                            onClick={() => setOpenRowActionsId(null)}
                                          >
                                            <Icon name={'attach'} />
                                            Gerenciar Anexos
                                          </Button>
                                        }
                                        bondInsuranceId={id}
                                        tableName={'CLAIM_ESTATES'}
                                        fileIdentifiers={FileIdentifiersAll}
                                        callback={(data, files) =>
                                          callback(data, files, id)
                                        }
                                        brokerOnly={true}
                                        tenantName={tenantName}
                                        disabled={
                                          status === ClaimEstatesStatusEnum.finished
                                        }
                                      />
                                    </Dropdown.Item>
                                    {user.role.includes('ESTATE') && (
                                      <AuthorizationContainer
                                        action={ActionEnum.assignEstateResponsible}
                                        feature={FeatureEnum.claims}
                                      >
                                        <Dropdown.Item>
                                          <Button
                                            style={{ cursor: 'pointer' }}
                                            fluid={true}
                                            type="button"
                                            color="purple"
                                            onClick={() => {
                                              setSelectedItem(item);
                                              setOpenSetEstateResponsible(true);
                                            }}
                                          >
                                            <Icon name="user" />
                                            {estateResponsible
                                              ? 'Alterar responsável'
                                              : 'Atribuir responsável'}
                                          </Button>
                                        </Dropdown.Item>
                                      </AuthorizationContainer>
                                    )}
                                    {
                                      //status !== "FINISHED" &&
                                      !user.role!.includes('ESTATE') && (
                                        <AuthorizationContainer
                                          action={ActionEnum.update}
                                          feature={FeatureEnum.claims}
                                        >
                                          {resolvedProductType ===
                                          ClaimProductTypeEnum.BOND ? (
                                            <Dropdown.Item>
                                              <Button
                                                style={{ cursor: 'pointer' }}
                                                fluid={true}
                                                type="button"
                                                color="yellow"
                                                onClick={() => {
                                                  handleEdit(id);
                                                }}
                                              >
                                                <Icon name={'pencil alternate'} />
                                                Editar
                                              </Button>
                                            </Dropdown.Item>
                                          ) : (
                                            <Dropdown.Item>
                                              <Button
                                                style={{ cursor: 'pointer' }}
                                                fluid={true}
                                                type="button"
                                                color="yellow"
                                                onClick={() => {
                                                  setEditProductType(resolvedProductType);
                                                  setEditIdToEdit(id);
                                                }}
                                              >
                                                <Icon name={'pencil alternate'} />
                                                Editar
                                              </Button>
                                            </Dropdown.Item>
                                          )}
                                          <Dropdown.Item>
                                            <Button
                                              style={{ cursor: 'pointer' }}
                                              fluid={true}
                                              type="button"
                                              color="orange"
                                              onClick={() => {
                                                setCloneProductType(resolvedProductType);
                                                setCloneIdToClone(id);
                                              }}
                                            >
                                              <Icon name={'clone'} />
                                              Clonar
                                            </Button>
                                          </Dropdown.Item>
                                          {resolvedProductType ===
                                            ClaimProductTypeEnum.BOND &&
                                            propertyStatus ===
                                              ClaimPropertyStatusEnum.occupied && (
                                            <Dropdown.Item>
                                              <Button
                                                style={{ cursor: 'pointer' }}
                                                fluid={true}
                                                type="button"
                                                color="brown"
                                                onClick={() => {
                                                  handleVacate(id, insurerName);
                                                }}
                                              >
                                                <Icon name={'reply'} />
                                                Desocupar imóvel
                                              </Button>
                                            </Dropdown.Item>
                                          )}
                                        </AuthorizationContainer>
                                      )
                                    }
                                  </>
                                </Dropdown.Menu>
                              </Dropdown>
                            </Menu.Item>
                          )}
                        </Menu>
                      </Table.Cell>
                    </ClickableTableRow>
                  </>
                );
              })}
            </>
          ) : (
            <Table.Row>
              <Table.Cell colSpan={9} textAlign={'center'}>
                <span>{getListEmptyMessage(props.user?.role, props.user?.estateUnitId)}</span>
              </Table.Cell>
            </Table.Row>
          )}
        </Dimmer.Dimmable>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={9} textAlign={'right'}>
              {!isLoading && (
                <TablePaginationMenu
                  currentPage={currentPage}
                  dataCount={count}
                  setCurrentPage={setCurrentPage}
                />
              )}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <DetailModal open={openDetail} claimId={id} close={() => setOpenDetail(false)} />
      <EditClaimEstateModal
        users={users!}
        claimId={id}
        open={isEditModalIsOpen}
        close={() => setEditModalIsOpen(false)}
        onSuccess={() => {
          getData();
          getCountData();
        }}
      />
      {openCreateClaimModal && selectedPolicyForClaim && (
        <CreateClaimEstateModal
          onlyModal={true}
          policy={selectedPolicyForClaim}
          onClose={() => {
            setOpenCreateClaimModal(false);
            setSelectedPolicyForClaim(null);
            getData();
          }}
        />
      )}

      {draftIdToResume &&
        draftProductTypeToResume === ClaimProductTypeEnum.BOND && (
          <CreateClaimEstateModal
            onlyModal={true}
            draftId={draftIdToResume}
            onClose={() => {
              setDraftIdToResume(null);
              getData();
            }}
          />
        )}

      {draftIdToResume &&
        draftProductTypeToResume !== ClaimProductTypeEnum.BOND && (
          <CreateOtherProductClaimModal
            open={true}
            productType={draftProductTypeToResume}
            draftId={draftIdToResume}
            onClose={() => {
              setDraftIdToResume(null);
              getData();
            }}
          />
        )}

      {cloneIdToClone && cloneProductType === ClaimProductTypeEnum.BOND && (
        <CreateClaimEstateModal
          onlyModal={true}
          cloneId={cloneIdToClone}
          onClose={() => {
            setCloneIdToClone(null);
            getData();
          }}
        />
      )}

      {cloneIdToClone && cloneProductType !== ClaimProductTypeEnum.BOND && (
        <CreateOtherProductClaimModal
          open={true}
          productType={cloneProductType}
          cloneId={cloneIdToClone}
          onClose={() => {
            setCloneIdToClone(null);
            getData();
          }}
        />
      )}

      {editIdToEdit && (
        <CreateOtherProductClaimModal
          open={true}
          productType={editProductType}
          editId={editIdToEdit}
          users={users!}
          onClose={() => {
            setEditIdToEdit(null);
            getData();
            getCountData();
          }}
        />
      )}

      {openSetEstateResponsible && selectedItem && (
        <SetEstateResponsibleModal
          isOpen={openSetEstateResponsible}
          onClose={() => setOpenSetEstateResponsible(false)}
          claimId={selectedItem.id}
          estateId={
            selectedItem.estateId ||
            user?.estate?.id ||
            availableBrokersAndEstates?.activeEstateId
          }
          responsible={selectedItem.estateResponsible?.id || null}
          onSuccess={() => getData()}
        />
      )}

      {openVacateModal && (
        <VacatePropertyClaimModal
          fileIdentifiers={getFileIdentifiers({
            values: {
              claimProperty: {
                status: ClaimPropertyStatusEnum.vacant
              }
            }
          } as any)}
          claimId={claimVacate ? claimVacate.id : ''}
          insurerName={claimVacate ? claimVacate.insurerName : ''}
          onClose={() => setOpenVacateModal(false)}
          callback={() => getData()}
        />
      )}

      <PopupModal locationActivation={BannerLocationActivationEnum.CLAIM_LIST} />
    </>
  );
};
export default connect(mapState, mapDispatch)(ClaimTable);
